module.exports = __webpack_public_path__ + "static/onama-f784ad52eb613cfc44834a10f52300d2.jpg";